import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromUserProfile from '../../user-profile.reducer';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-user-image',
  templateUrl: './user-image.component.html'
})
export class UserImageComponent {
  userProfile = new BehaviorSubject<any>({});
  userProfileData:any = null;
  @Input() isHeader = false;
  destroy$ = new Subject<void>();

  constructor(private readonly store: Store<fromUserProfile.UserProfileState>,
    public readonly cs: CommonService
  ) {
    this.getProfile();
  }


  getProfile() {
    this.store.select(fromUserProfile.getUserProfileItems)
    .pipe(takeUntil(this.destroy$))
    .subscribe((res) => {
      this.userProfile.next(res);
      this.userProfileData = res;
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
